module.exports = __webpack_public_path__ + "img/goal-icon.021c9018.png";